var swiperBanner = new Swiper('#banners-swiper', {
    mousewheel: {
        forceToAxis: true, // jen vodorovné gesto (2 prsty doleva/doprava na trackpadu)
    },
    pagination: {
        el: '.swiper-pagination-banners',
        clickable: true,
    },
    autoplay: {
        delay: 5000,
        disableOnInteraction: false,
    },
});